import {
  Box,
  Card,
  Button,
  Typography,
  CircularProgress,
  useMediaQuery,
  useTheme,
  TextField,
  InputAdornment,
  Pagination,
  Grid,
} from "@mui/material";
import InQueueDrawer from "../noc/InQueueDrawer";
import { useNavigate, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { enableEmptyCountyFlag } from "../../store/actions/dataActions";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import axios from "axios";
import DefaultModal from "../modals/DefaultModal";
import EmptyPermitPopover from "../popover/EmptyPermitPopover";
import StartPermit from "../permitComponents/StartPermit";
import PushPinIcon from "@mui/icons-material/PushPin";
import { useTour } from "@reactour/tour";
import SelectCountyForm, { getCountyData } from "../noc/SelectCountyForm";
import { loadPermitTemplate } from "../../store/actions/dataActions";
import { setAttachingNewPermit } from "../../store/actions/uiActions/myPermitsActions";

const CreateNoc = () => {
  //? REDUX CURRENT USER/SESSION #######################################################
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);
  const { nocData } = useSelector((state) => state.nocData);
  const { attachingNewPermit } = useSelector(
    (state) => state.myPermitsComponent,
  );
  //? ##################################################################################

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  let initAttachedRef = useRef(null);
  const { isOpen, currentStep } = useTour();

  const tabletSize = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const intervalId = null;

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedName, setSelectedName] = useState([]);
  const [selectedForm, setSelectedForm] = useState([]);
  const [cardRemain, setCardRemain] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const cardPerPage = 8;
  const [countiesData, setCountiesData] = useState([]);
  const [filteredCountiesData, setFilteredCountiesData] = useState([
    countiesData,
  ]);
  const [dataLoading, setDataLoading] = useState(true);
  const [selectedPreForm, setSelectedPreForm] = useState("");

  const [preview, setPreview] = useState(false);
  const [previewImg, setPreviewImg] = useState([]);
  const [openDefaultModal, setOpenDefaultModal] = useState(false);

  const [favoritesOpen, setFavoritesOpen] = useState(false);
  const [defaultAddress, setDefaultAddress] = useState({
    street: "",
    number: "",
    unit: "",
    suffix: "",
    zip: "",
    fullAddress: "",
    retrieved: "",
    fullRetrieve: "",
  });
  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const lg = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const [inQueueDrawer, setInQueueDrawer] = useState(false);
  const [newRequest, setNewRequest] = useState(false);
  const [newRequestID, setNewRequestID] = useState("");
  const [selectedPreName, setSelectedPreName] = useState("");
  const [selectedJurId, setSelectedJurId] = useState("");

  const [cancelDefaultLoading, setCancelDefaultLoading] = useState(false);

  //! START PERMIT ///////////////////////////////////////////////////
  const [startPermitOpen, setStartPermitOpen] = useState(false);
  const [availableCitiesNum, setAvailableCitiesNum] = useState(0);
  const [availableFormsNum, setAvailableFormsNum] = useState(0);
  const [displayImage, setDisplayImage] = useState(null);
  const [readyLoad, setReadyLoad] = useState(false);
  const currentTimezone =
    currentUser?.user?.personal?.[0]?.timezone ||
    currentUser?.subuser?.timezone;

  //! ////////////////////////////////////////////////////////////////

  //! Mobile /////////////////////////////////////////
  const [addEnabled, setAddEnabled] = useState(false);

  const [moreResultsNotificationData, setMoreResultsNotificationData] =
    useState(location.state?.selectedRow);

  const handleToggleFavorites = () => {
    setCurrentPage(1);
    setFavoritesOpen(!favoritesOpen);
    const inputElement = document.getElementById("searchInput");
    if (inputElement) {
      inputElement.value = ""; // Clear the search input value
    }
  };

  useEffect(() => {
    if (attachingNewPermit.started && !initAttachedRef?.current) {
      initAttachedRef.current = true;

      // getCountyData expects an object with a name property; attachingNewPermit.county is a string
      const countyData = getCountyData(
        { name: attachingNewPermit.county },
        nocData,
        currentTimezone,
      );

      const numCities = countyData.numCities;
      const numForms = countyData.numForms;

      setStartPermitOpen(true);
      setDisplayImage([]);
      setSelectedPreForm(attachingNewPermit.form.form);
      setSelectedPreName(attachingNewPermit.county);
      setAvailableCitiesNum(numCities);
      setAvailableFormsNum(numForms);
      setReadyLoad(true);
      dispatch(loadPermitTemplate(countyData));

      return;
    }
  }, [
    attachingNewPermit.county,
    attachingNewPermit.form,
    attachingNewPermit.started,
    attachingNewPermit.city,
    currentTimezone,
    dispatch,
    nocData,
  ]);

  // Hydrate attachingNewPermit from navigation state as a fallback
  useEffect(() => {
    if (!attachingNewPermit?.started && location?.state?.attachingNewPermit) {
      dispatch(setAttachingNewPermit(location.state.attachingNewPermit));
    }
  }, [attachingNewPermit?.started, location?.state, dispatch]);

  useEffect(() => {
    return () => {
      initAttachedRef.current = null;
      dispatch(
        setAttachingNewPermit({
          started: false,
          taskId: "",
          form: {},
          county: "",
          city: "",
          addedPermits: [],
          prevPermitGrid: {
            page: 0,
            pageSize: 5,
            rowCount: 0,
          },
        }),
      );
    };
  }, [dispatch]);

  useEffect(() => {
    if (isOpen) {
      if (currentSession === "userSession") {
        if (currentStep === 9 && startPermitOpen === true) {
          setStartPermitOpen(false);
        }
      } else if (currentSession === "subUserSession") {
        if (currentStep === 7 && startPermitOpen === true) {
          setStartPermitOpen(false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  //! MOBILE - DATA FROM NOTIFICATIONS ////////////
  useEffect(() => {
    if (moreResultsNotificationData && filteredCountiesData) {
      const currentIndex = filteredCountiesData.findIndex(
        (item) =>
          item.name === moreResultsNotificationData?.originalValues?.county,
      );

      const originalValues = moreResultsNotificationData?.originalValues;

      if (currentIndex !== -1) {
        setAddEnabled(true);
        // formik.setValues({ ...formik.values, ...originalValues });
        setSelectedPreName(originalValues?.county);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moreResultsNotificationData, filteredCountiesData]);
  //! ////////////////////////////////////////////

  useEffect(() => {
    if (addEnabled && !tabletSize) {
      setAddEnabled(false);
    }
  }, [addEnabled, tabletSize]);

  // ! ///////////////////////////////////////////////

  useEffect(() => {
    if (isMd && openDrawer === true) {
      setOpenDrawer(false);
    }

    if (!isMd && moreResultsNotificationData) {
      setMoreResultsNotificationData(null);
    }
  }, [isMd, openDrawer, moreResultsNotificationData]);

  const updateNotification = async (task_id) => {
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/update-notification`,
      { task_id: task_id, currentSession: currentSession },
      { withCredentials: true },
    );
  };

  useEffect(() => {
    if (
      currentUser &&
      currentUser.user &&
      currentUser.user.selectedCountiesNOC &&
      !currentUser.user.selectedCountiesNOC.some(
        (county) => selectedPreForm === county.cover,
      )
    ) {
      setOpenDrawer(false);
    }

    if (openDrawer === false) {
      setOpenDrawer(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPreForm, currentUser?.user?.selectedCountiesNOC]);

  useEffect(() => {
    if (newRequest === true) {
      const targetTask = currentUser?.nocUserTasks.find(
        (task) => task.task_id === newRequestID,
      );
      if (targetTask) {
        if (targetTask.status === "completed") {
          clearInterval(intervalId);
          if (targetTask.success === "more") {
            if ((openDrawer || addEnabled) && !inQueueDrawer) {
              setDefaultAddress({
                ...defaultAddress,
                retrieved: !targetTask.original_values.allRetrieve
                  ? String(targetTask.listPerPage)
                  : targetTask.return_values.length,
                fullRetrieve: !targetTask.original_values.allRetrieve
                  ? String(targetTask.numberOfLists)
                  : targetTask.return_values.length,
              });

              updateNotification(targetTask.task_id);
            }

            setNewRequest(false);
            setNewRequestID("");
          } else if (
            targetTask.success === true &&
            targetTask?.return_values?.signed
          ) {
            if ((openDrawer || addEnabled) && !inQueueDrawer) {
              if (tabletSize === true) {
                navigate("/dashboard", {
                  state: { nocReady: true },
                });
                return;
              }

              setPreview(true);
              setPreviewImg(targetTask.return_values?.signed);
              updateNotification(targetTask.task_id);
            }

            setNewRequest(false);
            setNewRequestID("");
          } else if (targetTask.success === false) {
            if ((openDrawer || addEnabled) && !inQueueDrawer) {
              updateNotification(targetTask.task_id);
            }
            setNewRequest(false);
            setNewRequestID("");
          } else if (targetTask.success === "waiting_list") {
            setNewRequest(false);
            setNewRequestID("");
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, newRequest]);

  useEffect(() => {
    if (currentUser?.user?.expired === true) {
      navigate("/subscription");
    } else if (currentUser.user.selectedCountiesNOC.length === 0) {
      dispatch(enableEmptyCountyFlag(location.pathname));
      navigate("/selectcounties");
    } else {
      const favoritesExist =
        JSON.parse(localStorage.getItem("favorites")) || [];

      if (
        favoritesExist.length !== 0 &&
        currentUser.user.selectedCountiesNOC.length === 0
      ) {
        // Clear local storage
        localStorage.removeItem("favorites");
      }

      const updatedSelectedCounties = Array.from(
        new Map(
          (currentUser?.user?.selectedCountiesNOC || []).map(
            (selectedCounty) => {
              const countyData =
                currentUser?.displays?.county_cards?.jur_us_fl?.find(
                  (c) => c?.id === selectedCounty?.jurisdiction_id,
                );
              return [
                selectedCounty?.jurisdiction_id,
                {
                  jurisdiction_id: selectedCounty?.jurisdiction_id,
                  defaults: selectedCounty?.defaults,
                  added_name: selectedCounty?.added_name,
                  added_email: selectedCounty?.added_email,
                  locked: selectedCounty?.locked,
                  ...countyData,
                },
              ];
            },
          ),
        ).values(),
      );

      const updatedFavorites = favoritesExist.filter((favorite) =>
        updatedSelectedCounties.some(
          (selectedCounty) => selectedCounty.name === favorite.name,
        ),
      );
      localStorage.setItem("favorites", JSON.stringify(updatedFavorites));

      try {
        if (favoritesOpen) {
          // Load favorites from local storage
          const favorites = JSON.parse(localStorage.getItem("favorites")) || [];
          setCountiesData(favorites);
          setFilteredCountiesData(favorites);
        } else {
          setCountiesData([...updatedSelectedCounties]);
          setFilteredCountiesData([...updatedSelectedCounties]);
        }

        setDataLoading(false);
      } catch (e) {
        setDataLoading(false);

        // navigate("/login");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, favoritesOpen, nocData]);

  useEffect(() => {
    if (!openDrawer && intervalId) {
      clearInterval(intervalId);
    }
  }, [openDrawer, intervalId]);

  const normalizeStAbbr = (str) =>
    str.toLowerCase().replace(/\bst\.?\b/g, "saint");

  const handleSearch = (event) => {
    setCurrentPage(1);
    const rawValue = event.target.value.toLowerCase();
    const value = normalizeStAbbr(rawValue);

    const result = countiesData.filter((data) => {
      const name = normalizeStAbbr(data.name);
      return name.search(value) !== -1;
    });

    setFilteredCountiesData(result);
  };

  const getCurrentTasks = (tasks) => {
    const indexOfLastCard = currentPage * cardPerPage;
    const indexOfFirstCard = indexOfLastCard - cardPerPage;
    return tasks.slice(indexOfFirstCard, indexOfLastCard);
  };
  const handleDisplayNOC = () => {
    let nocLeft = "";

    if (
      currentUser?.user.role === "admin" ||
      currentUser?.user.role === "tester" ||
      currentUser?.user?.admin === true
    ) {
      nocLeft = 1000 - currentUser?.user.analytics.nocCreatedInPeriod;
    } else {
      nocLeft = currentUser?.user.analytics.availableNocInPeriod;
    }

    if (nocLeft === 0 || nocLeft < 0) {
      return (
        <Typography
          ml="auto"
          my={10}
          mr="auto"
          textAlign="center"
          variant="h5"
          color="error"
        >
          You have reached the limit of available NOC. <br />
          Please update your package or come back later.
        </Typography>
      );
    } else {
      return (
        <SelectCountyForm
          selectedForm={selectedForm}
          setOpenDefaultModal={setOpenDefaultModal}
          setFilteredCountiesData={setFilteredCountiesData}
          setCountiesData={setCountiesData}
          favoritesOpen={favoritesOpen}
          isSmallScreen={isSmallScreen}
          setSelectedPreForm={setSelectedPreForm}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          selectedName={selectedName}
          selectCards={selectCards}
          type="create-noc"
          preview={preview}
          setPreview={setPreview}
          previewImg={previewImg}
          getCurrentTasks={getCurrentTasks}
          filteredCountiesData={filteredCountiesData}
          setSelectedPreName={setSelectedPreName}
          setStartPermitOpen={setStartPermitOpen}
          setAvailableCitiesNum={setAvailableCitiesNum}
          setAvailableFormsNum={setAvailableFormsNum}
          setDisplayImage={setDisplayImage}
          setReadyLoad={setReadyLoad}
          setSelectedJurId={setSelectedJurId}
        />
      );
    }
  };

  const selectCards = (countyName, form) => {
    if (selectedName.includes(countyName)) {
      let copyArray = [...selectedName];
      let index = copyArray.indexOf(countyName);
      copyArray.splice(index, 1);

      let copyForm = [...selectedForm];
      let indexForm = copyForm.indexOf(form);
      copyForm.splice(indexForm, 1);

      setCardRemain(cardRemain + 1);
      setSelectedName(copyArray);
      setSelectedForm(copyForm);
    } else {
      if (cardRemain !== 0) {
        setSelectedName([...selectedName, countyName]);
        setSelectedForm([...selectedForm, form]);
        setCardRemain(cardRemain - 1);
      }
    }
  };

  return (
    <>
      {dataLoading ? (
        <>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100vh",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress color="warning" size="10rem" />
          </Box>
        </>
      ) : (
        <>
          <Box
            py={1}
            sx={{
              width: "100%",
              flexGrow: { xs: 0, md: 1 },
              minHeight: { xs: "auto", md: 0 },
              maxWidth: tabletSize ? undefined : "1500px",
              mx: "auto",
              display: "flex",
              flexDirection: "column",
              overflow: { xs: "visible", md: "hidden" },
            }}
          >
            <Card
              className="step10"
              sx={{
                py: { xs: 1.5, md: 2 },
                mx: { xs: 1, md: 2 },
                position: "relative",
                minHeight: { xs: "auto", md: 0 },
                flexGrow: { xs: 0, md: 1 },
                overflow: { xs: "visible", md: "hidden" },
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* HEADER */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  flexGrow: { xs: 0, md: 1 },
                  minHeight: { xs: "auto", md: 0 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    px: { xs: 1.5, md: 2 },
                    gap: { xs: 1.5, md: 2 },
                    mb: 1,
                    flexShrink: 0,
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: "100%", md: 150 },
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                    }}
                  ></Box>
                  <Box sx={{ flexGrow: 1, flexShrink: 1, minWidth: 0 }}>
                    {/* Middle Box */}
                    <Typography
                      mb={0}
                      textAlign="center"
                      variant={isSmallScreen ? "h6" : "h5"}
                      color="primary"
                    >
                      Creating New Permit Package
                    </Typography>
                    <Typography
                      color="primary"
                      textAlign="center"
                      variant={isSmallScreen ? "body2" : "subtitle2"}
                    >
                      {currentUser?.user.selectedCountiesNOC.length === 0
                        ? "Please select Counties before start creating Permit Package"
                        : "Begin by selecting the county for which you need to create a permit package."}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                        mt: 2,
                      }}
                    >
                      <Button
                        size="small"
                        color="primary"
                        sx={{
                          fontWeight: "bold",
                          width: { xs: "13rem", sm: "18rem", md: "20rem" },
                        }}
                        onClick={handleToggleFavorites}
                        variant={favoritesOpen ? "outlined" : "contained"}
                      >
                        MY COUNTIES
                      </Button>
                      <Button
                        size="small"
                        color="error"
                        sx={{
                          fontWeight: "bold",
                          width: { xs: "13rem", sm: "18rem", md: "20rem" },
                        }}
                        onClick={handleToggleFavorites}
                        variant={favoritesOpen ? "contained" : "outlined"}
                        endIcon={
                          <PushPinIcon sx={{ transform: "rotate(45deg)" }} />
                        }
                      >
                        PINNED COUNTIES
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        display: { xs: "flex", md: "none" },
                        justifyContent: "center",
                        mt: 2,
                        mb: 1,
                      }}
                    >
                      <Pagination
                        count={Math.ceil(
                          filteredCountiesData.length / cardPerPage,
                        )}
                        page={currentPage}
                        onChange={(e, value) => setCurrentPage(value)}
                        siblingCount={isSmallScreen ? 0 : 1}
                        size={isSmallScreen ? "small" : "medium"}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: { xs: "100%", md: 200 },
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                    }}
                  >
                    <TextField
                      id="searchInput"
                      onChange={(e) => {
                        handleSearch(e);
                      }}
                      size="small"
                      fullWidth
                      placeholder="SEARCH"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </Box>
                </Box>

                {/* HEADER END */}
                <Box
                  sx={{
                    px: { xs: 1.5, lg: 2 },
                    flexGrow: 1,
                    overflowY: { xs: "visible", md: "auto" },
                    maxHeight: {
                      xs: "none",
                      md: "calc(100vh - 350px)",
                      lg: "calc(100vh - 360px)",
                    },
                  }}
                >
                  <Grid
                    container
                    sx={{
                      width: "100%",
                      overflowY: { xs: "visible", md: "auto" },
                      maxHeight: { xs: "none", md: "100%" },
                    }}
                  >
                    {handleDisplayNOC()}
                  </Grid>
                </Box>
              </Box>
              {lg ? (
                <Box
                  sx={{
                    position: "fixed",
                    bottom: 100,
                    pb: 1,
                    width: "calc(100% - 280px)",
                    px: "auto",
                    left: "280px",
                    height: "40px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1,
                  }}
                >
                  <Pagination
                    count={Math.ceil(filteredCountiesData.length / cardPerPage)}
                    page={currentPage}
                    onChange={(e, value) => setCurrentPage(value)}
                    siblingCount={isSmallScreen ? 0 : 1}
                    size={isSmallScreen ? "small" : "medium"}
                  />
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    py: 2,
                  }}
                >
                  <Pagination
                    count={Math.ceil(filteredCountiesData.length / cardPerPage)}
                    page={currentPage}
                    onChange={(e, value) => setCurrentPage(value)}
                    siblingCount={isSmallScreen ? 0 : 1}
                    size={isSmallScreen ? "small" : "medium"}
                  />
                </Box>
              )}
            </Card>
          </Box>
          {/* NOC STARTED DRAWER */}
          <InQueueDrawer
            inQueueDrawer={inQueueDrawer}
            setInQueueDrawer={setInQueueDrawer}
            inQueueMessage=""
            isMd={isMd}
          />
          <DefaultModal
            openDefaultModal={openDefaultModal}
            setOpenDefaultModal={setOpenDefaultModal}
            setOpenDrawer={setOpenDrawer}
            cancelDefaultLoading={cancelDefaultLoading}
            setCancelDefaultLoading={setCancelDefaultLoading}
            selectedPreName={selectedPreName}
          />
        </>
      )}

      {/* EMPTY PERMIT NUMBER POPOVER */}
      <EmptyPermitPopover />

      <StartPermit
        startPermitOpen={startPermitOpen}
        setStartPermitOpen={setStartPermitOpen}
        county={selectedPreName}
        countyImg={selectedPreForm}
        availableCitiesNum={availableCitiesNum}
        availableFormsNum={availableFormsNum}
        displayImage={displayImage}
        setDisplayImage={setDisplayImage}
        readyLoad={readyLoad}
        setReadyLoad={setReadyLoad}
        attachingNewPermit={attachingNewPermit}
        selectedJurId={selectedJurId}
      />
    </>
  );
};

export default CreateNoc;
